import clsx from "clsx";
import { useId } from "react";

const PageHeader = ({
  title,
  description,
  eyebrow,
  customCss,
  headingClassName,
  descriptionClassName,
}) => {
  const headingId = useId();

  return (
    <div
      className={clsx(
        "mx-auto w-full max-w-3xl px-5 py-12 text-center",
        customCss,
      )}
    >
      {eyebrow && (
        <strong
          className="mona mb-3 block bg-gradient-to-br from-vblue2 via-vblue3 to-vcyan1 bg-clip-text text-[0.8125rem] font-bold uppercase tracking-widest text-transparent"
        >
          {eyebrow}
        </strong>
      )}
      <h1
        id={headingId}
        className={clsx(
          "text-3xl font-bold tracking-tight lg:text-4xl",
          headingClassName,
        )}
      >
        {title}
      </h1>
      {description && (
        <p
          className={clsx(
            "mx-auto mt-2.5 max-w-xl text-lg text-neutral-500",
            descriptionClassName,
          )}
        >
          {description}
        </p>
      )}
    </div>
  );
};

export default PageHeader;
